module.exports = __webpack_public_path__ + "img/sucesso.6af43607.gif";